import { Button, IconButton, Tooltip, useTheme } from "@mui/material";
import { rgba } from "polished";
import PropTypes from "prop-types";
import { useContext } from "react";
import { GridContext } from "src/context/GridContext/GridContext";

export default function GridSettingsBar_Button({
  onClick = () => {},
  children = null,
  toolTip = "",
  disabled = null,
  componentProps = {},
  size = "medium", // small, medium, large
  variant = "outlined", // contained, outlined, text
  component = "button", // button, iconButton
  className = "",
  toolTipPlacement = "bottom",
}) {
  const { isLoading } = useContext(GridContext) || {};
  const theme = useTheme();

  const isDisabled = disabled === false ? false : disabled === true ? true : isLoading;

  return (
    <Tooltip disableInteractive title={toolTip} placement={toolTipPlacement} arrow>
      <div className={className}>
        {component === "iconButton" ? (
          <IconButton
            disabled={isDisabled}
            sx={{
              height: size === "small" ? "35px" : size === "medium" ? "55px" : "70px",
              width: size === "small" ? "35px" : size === "medium" ? "55px" : "70px",
              borderRadius: "3px",
              // backgroundColor: rgba(theme.palette.primary.main, 0.1),
              "&:hover": {
                borderColor: "secondary.main",
                // backgroundColor: rgba(theme.palette.secondary.main, 0.3),
              },
            }}
            // variant={variant}
            onClick={onClick}
            {...componentProps}>
            {children}
          </IconButton>
        ) : (
          <Button
            disabled={isDisabled}
            className="center"
            sx={{
              height: size === "small" ? "35px" : size === "medium" ? "55px" : "70px",
              borderRadius: "3px",
              backgroundColor: rgba(theme.palette.primary.main, 0.1),
              "&:hover": {
                borderColor: "secondary.main",
                backgroundColor: rgba(theme.palette.secondary.main, 0.3),
              },
            }}
            variant={variant}
            onClick={onClick}
            {...componentProps}>
            {children}
          </Button>
        )}
      </div>
    </Tooltip>
  );
}

GridSettingsBar_Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  toolTip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  componentProps: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  component: PropTypes.oneOf(["button", "iconButton"]),
  className: PropTypes.string,
  toolTipPlacement: PropTypes.string,
};
